import React from 'react';
import './AgeModal.css';

export default function AgeModal({ onConfirm }) {
  return (
    <div className="age-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="age-modal-title">
      <div className="age-modal">
        <div className="age-modal-badge">18+</div>
        <h2 id="age-modal-title">Aldersbekræftelse påkrævet</h2>
        <p>
          Denne hjemmeside indeholder information om online casino og spil med penge.
          Indholdet er udelukkende beregnet til personer, der er fyldt <strong>18 år</strong>.
        </p>
        <p className="age-modal-sub">
          Ved at fortsætte bekræfter du, at du er mindst 18 år gammel og er bosat i Danmark.
          Spil ansvarligt – spil er underholdning, ikke en indkomstkilde.
        </p>
        <div className="age-modal-actions">
          <button className="btn btn-primary btn-lg" onClick={onConfirm}>
            Ja, jeg er over 18 år – gå til siden
          </button>
          <a
            href="https://www.google.dk/"
            className="btn btn-outline btn-lg"
            style={{ marginTop: '0.75rem' }}
          >
            Nej, forlad siden
          </a>
        </div>
        <p className="age-modal-help">
          Har du brug for hjælp med spil? Kontakt{' '}
          <a href="https://www.stopspillet.dk/" target="_blank" rel="noopener noreferrer">StopSpillet.dk</a>
        </p>
      </div>
    </div>
  );
}
